<kendo-pdf-export #vobpdf paperSize="A3" margin="0.5cm" style="font-size: 12px;" author="CereusSoftware"
    [landscape]="true" [repeatHeaders]="true" BorderStyle="solid" BorderColor="black" BorderWidth="1px"
    forcePageBreak=".page-break" [fileName]="vobExportFileName">
    <div *ngIf="vobOtherExportData != undefined" class="export-container">
        <!-- PDF LAYOUT -->

        <!-- VOB Header Image -->
        <div class="row mb-2">
            <div class="col-md-12">
                <div class="p-3" style="background-color: black;">
                    <div class="d-flex">
                        <h3 class="text-primary" style="line-height:3 !important">Verification of Benefits</h3>
                        <div class="col d-flex justify-content-end">
                            <img src="../../../../assets/img/nextus-logo.png" height="70" width="200" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content - PAGE# 1 -->
        <div class="row mb-2">
            <div class="col-md-6" *ngFor="let item of vobOtherExportData">
                <!-- Patient Demographics & Eligibility & Insurance Info -->
                <table class="table table-bordered" style="width: 100%;"
                    *ngIf="item.container !== 'Pre-Certification Requirements' && item.container != 'Co-Insurance' 
                    && item.container !== 'Exclusions' && item.container !== 'Call Details' && item.container !== 'Pharmacy Information'">
                    <tbody>
                        <tr>
                            <th class="bg-primary" colspan="2">{{item.container}}</th>
                        </tr>
                        <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                            <th style="width: 40%;">{{subItem.formFieldName}}</th>
                            <td style="width: 60%;" *ngIf="subItem.formFieldName=='Address'">
                                <div [innerHTML]="subItem.formFieldValue"></div>
                            </td>
                            <td style="width: 60%;"
                                *ngIf="subItem.formFieldName=='Insurance Phone' || subItem.formFieldName=='Member Service Phone' || subItem.formFieldName=='Phone No'">
                                {{subItem.formFieldValue | phonepipe}}</td>
                            <td style="width: 60%;"
                                *ngIf="subItem.isHighlight===0 && (subItem.formFieldName != 'Insurance Phone' && subItem.formFieldName != 'Member Service Phone' && subItem.formFieldName != 'Phone No' && subItem.formFieldName != 'Address') ">
                                {{subItem.formFieldValue}}
                            </td>
                            <td style="width: 60%;"
                                *ngIf="subItem.isHighlight===1 && (subItem.formFieldName != 'Insurance Phone' && subItem.formFieldName != 'Member Service Phone' && subItem.formFieldName != 'Phone No' && subItem.formFieldName != 'Address')">
                                <span class="highlight"> {{subItem.formFieldValue}} </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!--Pre-Certification & Services -->
                <table class="table table-bordered" *ngIf="item.container === 'Pre-Certification Requirements'">
                    <tbody>
                        <tr>
                            <th class="bg-primary" colspan="4">{{item.container}}</th>
                        </tr>
                        <ng-container *ngFor="let preCertItem of vobPreCertSerivesData">
                            <tr>
                                <th class="text-center"
                                    *ngFor="let title of getColumnKeys(jsonStringToArray(jsonStringToArray(preCertItem.data)[0].formFieldValue))">
                                    {{title}}</th>
                            </tr>
                            <ng-container *ngFor="let preCertSubItem of jsonStringToArray(preCertItem.data)">
                                <tr *ngFor="let data of jsonStringToArray(preCertSubItem.formFieldValue)">
                                    <td class="text-center"
                                        *ngFor="let title of getColumnKeys(jsonStringToArray(jsonStringToArray(preCertItem.data)[0].formFieldValue))">
                                        <div *ngIf="title.toLowerCase().includes('authrequiered')">
                                            <span class="highlight"
                                                *ngIf="data[title].toLowerCase().includes('not covered')">{{data[title]}}</span>
                                            <span *ngIf="!data[title].toLowerCase().includes('not covered')">
                                                {{data[title]}}</span>
                                        </div>
                                        <div *ngIf="!title.toLowerCase().includes('authrequiered')">{{data[title]}}
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <!-- IF PHARMACY INFO THERE THEN -->
                            <ng-container *ngFor="let subItem of jsonStringToArray(item.data)">
                                <tr *ngIf="(item.container === 'Pre-Certification Requirements') && hasPharmacyInfo">
                                    <th colspan="2" style="width: 40%;">{{subItem.formFieldName}}</th>
                                    <td colspan="2" style="width: 60%;"
                                        *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===1">
                                        <span class="highlight">{{subItem.formFieldValue}}</span>
                                    </td>
                                    <td colspan="2" style="width: 60%;"
                                        *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===0">
                                        {{subItem.formFieldValue}}
                                    </td>
                                    <td colspan="2" style="width: 60%;" *ngIf="subItem.formFieldName=='Pre-certification Number'">
                                        {{subItem.formFieldValue |phonepipe}}</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>

                <!--Pre-Certification Content -->
                <table class="table table-bordered"
                    *ngIf="item.container === 'Pre-Certification Requirements' && !hasPharmacyInfo"
                    style="width: 100%;">
                    <tbody>
                        <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                            <th style="width: 40%;">{{subItem.formFieldName}}</th>
                            <td style="width: 60%;"
                                *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===1">
                                <span class="highlight">{{subItem.formFieldValue}}</span>
                            </td>
                            <td style="width: 60%;"
                                *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===0">
                                {{subItem.formFieldValue}}
                            </td>
                            <td style="width: 60%;" *ngIf="subItem.formFieldName=='Pre-certification Number'">
                                {{subItem.formFieldValue |phonepipe}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Pharmacy Information -->
        <div class="row mb-2" *ngIf="hasPharmacyInfo">
            <div class="col-md-6" *ngFor="let item of vobPharmacyExportData">
                <div style="width:100%;" *ngIf="item.container === 'Pharmacy Information'">
                    <div class="col-md-6" *ngFor="let item of vobPharmacyExportData" style="width:100%;">
                        <!-- DON't REMOVE THIS TABLE AS IN USE EVEN HIDDEN -->
                        <table class="table table-bordered" *ngIf="item.container === 'Pre-Certification Requirements'"
                            style="width: 100%; display: none;">
                            <tbody>
                                <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                                    <th style="width: 40%;">{{subItem.formFieldName}}</th>
                                    <td style="width: 60%;"
                                        *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===1">
                                        <span class="highlight">{{subItem.formFieldValue}}</span>
                                    </td>
                                    <td style="width: 60%;"
                                        *ngIf="subItem.formFieldName!='Pre-certification Number' && subItem.isHighlight===0">
                                        {{subItem.formFieldValue}}
                                    </td>
                                    <td style="width: 60%;" *ngIf="subItem.formFieldName=='Pre-certification Number'">
                                        {{subItem.formFieldValue |phonepipe}}</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Pharmacy Information -->
                        <table class="table table-bordered" *ngIf="item.container === 'Pharmacy Information'"
                            style="width: 100%;">
                            <tbody>
                                <tr>
                                    <th class="bg-primary" colspan="2">{{item.container}}</th>
                                </tr>
                                <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                                    <th style="width: 40%;">{{subItem.formFieldName}}</th>
                                    <td style="width: 60%;">{{subItem.formFieldValue}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content - PAGE# 2 -->
        <div class="row mb-2" [ngClass]="{'page-break' : true}">
            <div class="col-md-12">
                <div class="p-3" style="background-color: black;">
                    <div class="d-flex">
                        <h3 class="text-primary" style="line-height:3 !important">Verification of Benefits
                        </h3>
                        <div class="col d-flex justify-content-end">
                            <img src="../../../../assets/img/nextus-logo.png" height="70" width="200" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Co-Insurance & Exclusions & Call Details-->
        <div class="row mb-2">
            <div class="col-md-6" *ngFor="let item of vobOtherExportData">
                <table class="table table-bordered" *ngIf="item.container === 'Co-Insurance'" style="width: 100%;">
                    <tbody>
                        <tr>
                            <th class="bg-primary" colspan="2">{{item.container}}</th>
                        </tr>
                        <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                            <th style="width: 40%;">{{subItem.formFieldName}}</th>
                            <td style="width: 60%;"
                                *ngIf="subItem.formFieldName=='Insurance Phone' || subItem.formFieldName=='Member Service Phone' || subItem.formFieldName=='Phone No'">
                                {{subItem.formFieldValue | phonepipe}}</td>

                            <td style="width: 60%;"
                                *ngIf="subItem.isHighlight===0 && (subItem.formFieldName != 'Insurance Phone' && subItem.formFieldName != 'Member Service Phone' && subItem.formFieldName != 'Phone No') ">
                                {{subItem.formFieldValue}}
                            </td>
                            <td style="width: 60%;"
                                *ngIf="subItem.isHighlight===1 && (subItem.formFieldName != 'Insurance Phone' && subItem.formFieldName != 'Member Service Phone' && subItem.formFieldName != 'Phone No')">
                                <span class="highlight"> {{subItem.formFieldValue}} </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- Exclusions & Call Details -->
                <div style="width:100%;" *ngIf="item.container === 'Exclusions'">
                    <div class="col-md-6" *ngFor="let item of vobExclusionExportDataOnly" style="width:100%;">
                        <!-- Exclusions -->
                        <table class="table table-bordered" *ngIf="item.container === 'Exclusions'"
                            style="width: 100%;">
                            <tbody>
                                <tr>
                                    <th class="bg-primary" colspan="2">{{item.container}}</th>
                                </tr>
                                <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                                    <th style="width: 40%;">{{subItem.formFieldName}}</th>
                                    <td style="width: 60%;" *ngIf="subItem.isHighlight===1"> <span class="highlight">
                                            {{subItem.formFieldValue}} </span></td>
                                    <td style="width: 60%;" *ngIf="subItem.isHighlight===0"> {{subItem.formFieldValue}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Call Details -->
                        <table class="table table-bordered" *ngIf="item.container === 'Call Details'"
                            style="width: 100%;">
                            <tbody>
                                <tr>
                                    <th class="bg-primary" colspan="2">{{item.container}}</th>
                                </tr>
                                <tr *ngFor="let subItem of jsonStringToArray(item.data)">
                                    <th style="width: 40%;">{{subItem.formFieldName}}</th>
                                    <td style="width: 60%;"> {{subItem.formFieldValue}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Notes & Disclaimer -->
        <div class="row mb-2">
            <div class="col-md-12">
                <table class="table table-bordered" style="border: 1px solid black;">
                    <tbody>
                        <tr>
                            <ng-container *ngFor="let item of vobNotesExportData">
                                <th *ngIf="item.container === 'Notes'" class="bg-primary col-md-8">
                                    {{item.container}} :</th>
                                <th *ngIf="item.container === 'Disclaimer'" class="bg-primary col-md-4">
                                    {{item.container}} :</th>
                            </ng-container>
                        </tr>
                        <tr>
                            <ng-container *ngFor="let item of vobNotesExportData">
                                <td *ngIf="item.container === 'Notes'" class="col-md-8">
                                    <div class="highlight"
                                        [innerHTML]="getSanitizedNotesHtml(jsonStringToArray(item.data)[0].formFieldValue)">
                                    </div>
                                </td>
                                <td *ngIf="item.container === 'Disclaimer'" class="col-md-4">
                                    {{jsonStringToArray(item.data)[0].formFieldValue}}
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row" style="float: left;" *ngIf="vobOtherExportData != undefined && isHide">
        <div class="top-action-btns">
            <ul>
                <li *ngIf="this.vobId> 0">
                    <a href="javascript:;" #downloadButton class="btn btn-primary"
                        (click)="saveVobPdfForEndUser(vobpdf)">
                        <span class="custom-icons icon-download m-r"></span>Download</a>
                </li>
                <li *ngIf="this.vobId> 0">
                    <a href="javascript:;" #downloadButton class="btn btn-danger text-white"
                        (click)="uploadVobPdfToSharepointFolder(vobpdf)">
                        <span class="custom-icons icon-download m-r"></span>Upload to Sharepoint</a>
                </li>
                <li *ngIf="this.vobId> 0">
                    <a href="javascript:;" #downloadButton class="btn btn-success text-white"
                        (click)="uploadPdfToCereusBlobStorage(vobpdf)">
                        <span class="custom-icons icon-download m-r"></span>Upload to Cereus</a>
                </li>
            </ul>
        </div>
    </div>
</kendo-pdf-export>
<div class="row" *ngIf="vobOtherExportData == undefined">
    <div class="top-action-btns">
        <h4 *ngIf="!isAutoDownload" style="text-align: center;">VOB information is pending. Please complete the VOB form
            to export!</h4>
        <h4 *ngIf="isAutoDownload" style="text-align: left;">VOB Form is incomplete are you sure would like to send this
            to facility?</h4>
    </div>
</div>

<!-- PDF Uploaded Dialog -->
<kendo-dialog title="Upload Alert" *ngIf="showUploadProgressMessage" (close)="closeUploadProgressMessage()"
    class="kendo-modal modal-md">
    <div class="common-popup-space text-center">
        <p> Uploading file is in progress can continue working!</p>
    </div>
    <kendo-dialog-actions class="d-block text-center">
        <button kendoButton (click)="closeUploadProgressMessage()" class="btn btn-cancel btn-sm">Ok</button>
    </kendo-dialog-actions>
</kendo-dialog>
<!-- PDF Uploaded Dialog -->